import React from "react";
import { Particles } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

function Particle() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        background: {
          color: "transparent",
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          number: {
            value: 80,
            density: {
              enable: true,
              area: 800,
            },
          },
          move: {
            enable: true,
            speed: 0.3,
            direction: "none",
          },
          size: {
            value: { min: 1, max: 3 },
          },
          opacity: {
            value: 0.5,
          },
        },
      }}
    />
  );
}

export default Particle;